import { taskFormElemDefs } from '../features/tasks/elements/factory';
import { TpTaskFormElemDef } from '../features/tasks/elements/interfaces';

let cachedElementSchema: any = null;

function generatSingleElementSchema(elemDef: TpTaskFormElemDef) {
  const elemSchema: any = {
    type: 'object',
    title: elemDef.name,
    description: elemDef.description,
    properties: {
      type: { type: 'string', const: elemDef.type },
      id: { type: 'string', description: 'Unique identifier of the element' },
      name: { type: 'string', description: 'Displayed name of the element' },
      visibleCondition: {
        type: 'string',
        description:
          'A boolean expression that determines the visibility of this element. In this expression, identifiers of other elements can be used.',
      },
    },
    required: ['id', 'name'],
  };
  if (elemDef.hasData) {
    elemSchema.properties.required = {
      type: 'boolean',
      description: 'Determines whether or not a value for this element must be provided by the user',
    };
    elemSchema.properties.defaultValue = {
      description: 'The initial value for this element when the form is displayed',
    };
  }
  if (elemDef.addSpecificSchema) elemDef.addSpecificSchema(elemSchema);
  return elemSchema;
}

function generateAllElementsSchema() {
  if (cachedElementSchema) return cachedElementSchema;

  cachedElementSchema = {
    anyOf: [],
  };

  for (const elemDef of taskFormElemDefs) {
    cachedElementSchema.anyOf.push(generatSingleElementSchema(elemDef));
  }
  return cachedElementSchema;
}

const schemaTaskFormTemplate = {
  type: 'object',
  properties: {
    taskDefinitionId: { type: 'string', description: 'Identifier of this template' },
    name: { type: 'string', description: 'Name of the task' },
    parentAssetType: { type: 'string', description: 'Identifier of the asset type this task template applies to' },
    description: { type: 'string', description: 'Brief summary of the task definition' },
    formDefinition: {
      type: 'object',
      properties: {
        elements: {
          type: 'array',
          description: 'The set of elements to be displayed on the form.',
          items: generateAllElementsSchema(),
        },
        validations: {
          type: 'array',
          description:
            'A set of validation rules for the form data that must be fulfilled before the form can be completed.',
          items: {
            type: 'object',
            properties: {
              test: {
                type: 'string',
                description:
                  'Boolean expression that must evaluat to true for the test to pass. This expression can use the identifier of elements in the form that contain data.',
              },
              errorMessage: {
                type: 'string',
                description: 'Error message to be displayed when the validation test fails.',
              },
            },
            required: ['test', 'errorMessage'],
          },
        },
      },
      required: ['elements'],
    },
  },

  required: ['templateId', 'displayName', 'assetType', 'formDefinition'],
  additionalProperties: false,
};

export default schemaTaskFormTemplate;
